<template>
  <div class="site-chooser">
    <div class="row">
      <div class="col-12 col-xl-8">
        <div class="row">
          <div class="col-md-6 col-lg-4 col-xl-4">
            <div class="form-group row">
              <label class="col-3 col-form-label">
                Brand:
              </label>
              <div class="col-9">
                <field-select
                  v-model="brand"
                  :options="brands"
                  class="form-control"
                  label="Select brand"
                  name="brand"

                />
              </div>
            </div>
          </div>
          <div class="col-md-6 col-lg-4 col-xl-4">
            <div class="form-group row">
              <label class="col-3 col-form-label">
                Website:
              </label>
              <div class="col-9">
                <field-select
                  v-model="site"
                  :disabled="!brand.label"
                  :options="sites"
                  class="form-control"
                  label="Select website"
                  name="site"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import FieldSelect from '@/components/form/FieldSelect'
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  name: 'SiteChooser',

  components: {
    FieldSelect
  },

  computed: {
    ...mapGetters({
      brands: 'brand/brandsSimple',
      activeBrand: 'brand/active',
      sites: 'site/sitesSimple',
      activeSite: 'site/active'
    }),

    brand: {
      get () {
        if (!this.activeBrand) {
          return {}
        }
        return {
          label: this.activeBrand.name,
          value: this.activeBrand.uuid
        }
      },
      set (newVal) {
        this.setActiveBrand(newVal)
        this.setActiveSite(void 0)
        this.$router.push('/brands/' + newVal)
      }
    },

    site: {
      get () {
        if (!this.activeSite) {
          return {}
        }
        return {
          label: this.activeSite.name + ' (' + this.activeSite.id + ')',
          value: this.activeSite.slug
        }
      },
      set (newVal) {
        this.setActiveSite(newVal)
        this.$router.push('/brands/' + this.activeBrand.uuid + '/sites/' + newVal + '/pages')
      }
    }
  },

  created () {
    this.getBrands().then(() => {
      let brandId = this.$route.params.brandId
      let siteId = this.$route.params.siteId
      if (siteId && siteId !== this.activeSite.slug) {
        if (brandId === this.activeBrand.uuid) {
          this.setActiveSite(siteId)
        } else {
          this.setActiveBrand(brandId)
          this.getSites(this.activeBrand.uuid).then(() => {
            this.setActiveSite(siteId)
          })
        }
      } else if (brandId && brandId !== this.activeBrand.uuid) {
        this.setActiveBrand(brandId)
        this.getSites(this.activeBrand.uuid)
        this.setActiveSite(void 0)
      }
    })
  },

  methods: {
    ...mapActions({
      getBrands: 'brand/get',
      getSites: 'site/get'
    }),
    ...mapMutations({
      setActiveBrand: 'brand/SET_ACTIVE',
      setActiveSite: 'site/SET_ACTIVE'
    })
  }
}
</script>

<style lang="scss">
  .site-chooser {
    background: #333;
    color: white;
    padding: 6px 30px;
    .form-group{
      margin-top: 0;
      margin-bottom: 0;
      min-height: 32px;
      .col-form-label{
        height: 34px;
        text-transform: uppercase;
        font-size: 14px;
        color: #999;
        font-weight: bold;
        letter-spacing: 0.5px;
        padding-top: 6px;
      }
    }
    .form-group {
      select{
        &.custom-select {
          display: inline-block;
          width: 100%;
          height: calc(28px + 4px);
          padding: .325rem 1.75rem .325rem .75rem;
          line-height: 1.3;
          color: #dedede;
          vertical-align: middle;
          background: #fff  url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3E%3Cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3E%3C/svg%3E") no-repeat right .75rem center;
          background-size: 8px 10px;
          background-color: #5d5d5d;
          border: 0;
          border-radius: 3px;
          -webkit-appearance: none;
          -moz-appearance: none;
          appearance: none;
        }
      }
      &.select-form-group{
        padding: 0;
        label{
          display:none;
        }
        input {
          color: #dedede;
          border: 0;
          background-color: #5d5d5d !important;
        }
      }
    }
  }

  .form-group.disabled {
    .input-group {
      opacity: 0.3;
    }
  }
// @import "~@/assets/scss/_variables.scss";

.navbar-site-select {
  margin-left: 30px;
  .form-group{
    margin-bottom:0 ;
  }
  .btn-fake {
    margin:0 10px;
    font-size: 20px;
  }
}

</style>
